export const checkEmail =
  'Password reset link has been sent to <b>email</b>. Click on the <b>Reset password</b> button in the e-mail you received to complete the reset process.';

export const space = ' ';

export const ticketCreated =
  'Your ticket <strong>{{ticket}}</strong> was created successfully. Go to ticket details to start resolving the issue.';
